import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, Button, Spinner, useIsMobile } from '../components/ui';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { refreshUser } = useAuth();
  const isMobile = useIsMobile();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setError('This verification link is missing a token.'); return; }
    api.post('/auth/verify-email', { token })
      .then(() => {
        setStatus('success');
        refreshUser?.();
      })
      .catch(e => {
        setStatus('error');
        setError(e.response?.data?.detail || 'This link is invalid or has expired.');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="bb-auth-shell" style={{
      background: 'var(--gray-50)',
      alignItems: 'center', justifyContent: 'center',
      padding: isMobile ? '24px 16px' : '48px 16px',
    }}>
      <Card style={{ maxWidth: '420px', width: '100%', textAlign: 'center' }}>
        {status === 'verifying' && (
          <div style={{ padding: '20px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}><Spinner size={28} /></div>
            <p style={{ fontSize: '14px', color: 'var(--gray-600)' }}>Verifying your email…</p>
          </div>
        )}
        {status === 'success' && (
          <div style={{ padding: '12px 0' }}>
            <div style={{ fontSize: '44px', marginBottom: '12px' }}>✅</div>
            <div style={{ fontSize: '17px', fontWeight: 700, color: 'var(--gray-900)', marginBottom: '8px' }}>Email verified!</div>
            <p style={{ fontSize: '13.5px', color: 'var(--gray-500)', marginBottom: '20px', lineHeight: 1.6 }}>
              You're one step closer — verify your phone number too so you can post and respond to requests.
            </p>
            <Link to="/"><Button variant="primary" fullWidth>Continue to HopeForSomeone →</Button></Link>
          </div>
        )}
        {status === 'error' && (
          <div style={{ padding: '12px 0' }}>
            <div style={{ fontSize: '44px', marginBottom: '12px' }}>⚠️</div>
            <div style={{ fontSize: '17px', fontWeight: 700, color: 'var(--gray-900)', marginBottom: '8px' }}>Couldn't verify email</div>
            <p style={{ fontSize: '13.5px', color: 'var(--gray-500)', marginBottom: '20px', lineHeight: 1.6 }}>{error}</p>
            <Link to="/"><Button variant="secondary" fullWidth>Back to home</Button></Link>
          </div>
        )}
      </Card>
    </div>
  );
}
